import TabSelectable from "@/Layouts/components/Tab/TabSelectable";

interface ITabProps {
	title: string | undefined;
	disabled: boolean;
	badgeValue?: string;
}

interface ITabsSplitPayPeriodProps {
	badgeValues: Record<number, number>;
	tabs: ITabProps[];
	tabSelected: number;
	setTabSelected: (tabIndex: number) => void;
	memoizedContentMap: React.ReactNode[];
}
const resolveBadgeValue = (value: number) => {
	return value ? value.toString() : "";
};

export const TabsSplitPayPeriod = (props: ITabsSplitPayPeriodProps) => {
	const { badgeValues, tabs, tabSelected, setTabSelected, memoizedContentMap } = props;
	return (
		<TabSelectable
			tabs={tabs.map((tab, index) => ({
				...tab,
				badgeValue: resolveBadgeValue(badgeValues[index]),
			}))}
			tabSelected={tabSelected}
			content={memoizedContentMap}
			onTabChange={setTabSelected}
			useMUITabPanel
		/>
	);
};
